/**
 * Environment-Aware Security Logger
 * 
 * Provides detailed security event logging in development while maintaining
 * privacy and performance in production environments.
 */

// Use both NODE_ENV and REACT_APP_ENVIRONMENT for more reliable detection
const isDevelopment = process.env.NODE_ENV === 'development' || 
                     process.env.REACT_APP_ENVIRONMENT === 'development';

const securityLogger = {
  /**
   * Security warnings (dev: full console, prod: silent or telemetry)
   * @param {string} message - The warning message
   * @param {object} data - Optional data object with context
   */
  warn: (message, data) => {
    if (isDevelopment) {
      console.warn('⚠️ SECURITY WARNING: ' + message, data || '');
    }
    // Production: Silent or optional telemetry hook
    // Future implementation could include telemetry service call here
  },

  /**
   * Security events (dev: console, prod: silent)
   * @param {string} message - The log message
   * @param {object} data - Optional data object with context
   */
  log: (message, data) => {
    if (isDevelopment) {
      console.log('🔍 SECURITY: ' + message, data || '');
    }
    // Production: Silent
  },

  /**
   * Critical errors (dev: full details, prod: completely silent)
   * @param {string} message - The error message
   * @param {object} data - Optional data object with context
   */
  error: (message, data) => {
    if (isDevelopment) {
      console.error('❌ SECURITY ERROR: ' + message, data || '');
    }
    // Production: Completely silent
  },

  /**
   * Debug information (dev: verbose, prod: completely silent)
   * @param {string} message - The debug message
   * @param {object} data - Optional data object with context
   */
  debug: (message, data) => {
    if (isDevelopment) {
      console.log('🔧 SECURITY DEBUG: ' + message, data || '');
    }
    // Production: Completely silent
  }
};

export default securityLogger;
